import { HttpClient } from '@angular/common/http';
import {
    Component,
    Input,
    OnChanges,
    OnInit,
    SimpleChanges,
} from '@angular/core';
import { UserProfileInterface } from 'src/app/interface/user-profile.interface';

@Component({
    selector: 'app-component-user-balance',
    templateUrl: './balance.component.html',
    styleUrls: ['./balance.component.css'],
})
export class BalanceComponent implements OnChanges {
    @Input() public userProfile?: UserProfileInterface;
    constructor(private httpClient: HttpClient) {}

    ngOnChanges(changes: SimpleChanges): void {
        if ('user' in changes) {
            console.log('lookup user balance');
        }
    }
}
